define('plugin/invoice/view/InvoiceDetailsView',['require','lib/view/LayoutView','lib/view/ModalRegion','view/controller/booking/result/BookingResultPopup','lib/model/BaseModel','Config','lib/view/mixin/BookingResultPopupMixin'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var ModalRegion = require('lib/view/ModalRegion');
    var BookingResultPopup = require('view/controller/booking/result/BookingResultPopup');
    var BaseModel = require('lib/model/BaseModel');
    var Config = require('Config');
    var BookingResultPopupMixin = require('lib/view/mixin/BookingResultPopupMixin');

    /**
     * Invoice details view
     *
     * @class InvoiceDetailsView
     */
    return LayoutView.extend({

        template: '#invoice_details_view',
        modelEvents: {
            'sync': 'safeRender'
        },
        _isDirectLink: null,

        initialize: function () {
            LayoutView.prototype.initialize.call(this);
            this._clientModel = this.getOption('clientModel');
            this.resultPopupRegion = null;
            this._isDirectLink = this.getOption('isDirectLink');

            this.listenTo(this, 'render', this._afterRenderView);
        },

        safeRender: function () {
            if (!this.isDestroyed) {
                this.render();
            }
        },

        showTermsAndConditions: function (view) {
            if(this.terms.$el.length){
                this.terms.show(view);
            }
        },

        serializeData: function () {
            var result = LayoutView.prototype.serializeData.apply(this);
            result.type = null;

            if (result.lines) {
                result.lines = result.lines.toJSON();
                _.each(result.lines, function (line) {
                    if(line && line.type) {
                        result.type = line.type;
                    }
                });
            }
            if (result.taxes) {
                result.taxes = result.taxes.toJSON();
            }
            result.is_payment_allowed = this.getOption('paymentAllowed');

            return result;
        },

        _afterRenderView: function (){
            var lines = this.model.get('lines');
            var isBooking = false;
            var bookingIds = [];

            if(lines) {
                lines.each(function (line) {
                    if(line.get('type') === 'booking' || (line.get('type') === 'deposit' && line.get('booking_ids'))){
                        isBooking = true;
                        bookingIds = _.extend(bookingIds, line.get('booking_ids'))
                    }
                });
            }

            var showPopup = true;

            if(this._isDirectLink){
                showPopup = false;
            }

            if(isBooking && showPopup){
                if(Config.getInstance().getOption('enable_push_notifications')) {
                    this.showResultPopup(bookingIds);
                }
            }
        },


        showResultPopup: function (bookingIds) {
            var region = new ModalRegion();
            var status = this.model.get('status');
            var paymentProcessor = this.model.get('payment_processor');
            var paymentReceived = this.model.get('payment_received');
            if(status === 'paid'){
                status = 'success';
            }
            if(paymentProcessor === 'delay' && !paymentReceived){
                status = 'delay';
            }

            if(!BookingResultPopupMixin.isShowInvoicePopup(bookingIds, this.model)){
                return;
            }
            var key = 'payment_status_message_' + status;
            var mess = Locale.getNonEscape(key);

            if(mess === key){
                mess = Locale.getNonEscape('booking_status_' + status);
            }

            if(this.model.get('status') === 'paid' && !paymentReceived && bookingIds.length > 0 && Config.getInstance().getPluginStatus('approve_booking')){
                mess = Locale.getNonEscape('Your booking is still pending! You will receive a confirmation as soon as the administrator has processed it.');
            }

            var view = new BookingResultPopup({
                region: region,
                model: new BaseModel({
                    status: status,
                    booking_ids: bookingIds,
                    message: mess,
                    invoice: true,
                    payment_processor: paymentProcessor,
                    payment_received: paymentReceived,
                    has_bookings: bookingIds.length > 0
                }),
            });
            region.show(view);
        },

    });

});
